import PropTypes from 'prop-types'

export const HERO_ROLES = {
    TAKE_QUIZ: 'take_quiz',
    CONTINUE: 'continue'
}

export const buttonFunctions = {
    linkToPage: 'Link to Page',
    linkToElement: 'Link to Element',
    nothing: 'Nothing'
}

export const queryParamInputOption = {
    name: 'queryParams',
    friendlyName: 'Url Query Params',
    type: 'list',
    subFields: [
        {
            name: 'name',
            type: 'string',
            helperText: 'The name of the url parameter (i.e "id")'
        },
        {
            name: 'value',
            type: 'string',
            helperText: 'The value of the url parameter (i.e "123")'
        }
    ],
    showIf: `options.get('clickFunction') === '${buttonFunctions.linkToPage}' && options.get('isInternalLink') === true`,
    helperText: 'Additional parameters to add to the end of a page url. (i.e /product?id=123'
}

export const coreButtonInputs = [
    {
        name: 'clickFunction',
        type: 'text',
        enum: Object.values(buttonFunctions),
        required: true,
        defaultValue: buttonFunctions.linkToPage,
        helperText:
            'Define if the button is meant to link to another page or to an element on the current page'
    },
    {
        name: 'scrollTargetId',
        type: 'text',
        helperText: 'The ID value of the element this button should scroll to.',
        showIf: `options.get('clickFunction') === '${buttonFunctions.linkToElement}'`,
        required: true
    },
    {
        name: 'isInternalLink',
        type: 'boolean',
        helperText: 'Select "true" if the link will be routing to a page in our storefront.',
        showIf: `options.get('clickFunction') === '${buttonFunctions.linkToPage}'`,
        required: false,
        defaultValue: true
    },
    {
        name: 'pageReference',
        type: 'reference',
        showIf: `options.get('clickFunction') === '${buttonFunctions.linkToPage}' && options.get('isInternalLink') === true`,
        required: true
    },
    queryParamInputOption,
    {
        name: 'externalLinkReference',
        type: 'reference',
        model: 'external-links',
        showIf: `options.get('clickFunction') === '${buttonFunctions.linkToPage}' && options.get('isInternalLink') === false`,
        required: true
    },
    {
        name: 'openInNewTab',
        type: 'boolean',
        helperText: 'Select "true" if the link must be opened in a new tab.',
        defaultValue: false,
        showIf: `options.get('clickFunction') === '${buttonFunctions.linkToPage}'`
    },
    {
        name: 'isRevShare',
        type: 'boolean',
        helperText: 'Select "true" if the link is Rev-Share link.',
        defaultValue: false
    }
]

export const coreButtonPropTypes = {
    children: PropTypes.node,
    attributes: PropTypes.object,
    clickFunction: PropTypes.string.isRequired,
    scrollTargetId: PropTypes.string,
    isInternalLink: PropTypes.bool,
    isRevShare: PropTypes.bool,
    openInNewTab: PropTypes.bool,
    pageReference: PropTypes.shape({
        value: PropTypes.shape({
            data: PropTypes.shape({
                isSfraPage: PropTypes.bool,
                url: PropTypes.string
            })
        })
    }),
    queryParams: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            value: PropTypes.string
        })
    ),
    externalLinkReference: PropTypes.shape({
        value: PropTypes.shape({
            data: PropTypes.shape({
                url: PropTypes.string
            })
        })
    })
}
